import { TServices } from "../@types/TServices";
import { CampaignService } from "../services/campaignService";
import { make88iClientApi } from "./make88iClientApi";

export const makeInjectedServices = (): TServices => ({
  campaignService: new CampaignService(make88iClientApi("campaign")),
});
